import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/spinners/eclipse.svg'


const _hoisted_1 = { class: "h-full w-full" }
const _hoisted_2 = {
  key: 0,
  class: "w-full h-full content-transparent"
}
const _hoisted_3 = { class: "colCenter marg-s" }
const _hoisted_4 = { class: "h4" }
const _hoisted_5 = {
  key: 1,
  class: "row-top w-full h-full"
}
const _hoisted_6 = { class: "sub-menu h-full" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "h4" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "menu-col-1" }
const _hoisted_12 = {
  key: 0,
  class: "menu-col-2"
}
const _hoisted_13 = { class: "row-top mtop-20" }
const _hoisted_14 = { class: "menu-col-1" }
const _hoisted_15 = { class: "bg-modal w-maxC" }
const _hoisted_16 = {
  key: 0,
  class: "menu-col-2"
}
const _hoisted_17 = { class: "row pad-s" }
const _hoisted_18 = { class: "col mtop-04" }
const _hoisted_19 = { class: "menu-col-1" }
const _hoisted_20 = {
  key: 0,
  class: "menu-col-2"
}
const _hoisted_21 = { class: "font-m main-l align-l" }
const _hoisted_22 = {
  key: 1,
  class: "menu-col-2"
}
const _hoisted_23 = {
  key: 0,
  class: "bg-pid-ra rnd-s mleft-04 psides-04 mtop-01"
}
const _hoisted_24 = {
  key: 1,
  class: "bg-pid-ra rnd-s mleft-04 psides-04 row"
}
const _hoisted_25 = {
  key: 2,
  class: "bg-pid-ra rnd-s mleft-04 psides-04 mtop-01"
}
const _hoisted_26 = {
  key: 3,
  class: "bg-pid-ra rnd-s mleft-04 psides-04 mtop-01"
}
const _hoisted_27 = {
  key: 4,
  class: "bg-pid-ra rnd-s mleft-04 psides-04 mtop-01"
}
const _hoisted_28 = {
  key: 5,
  class: "bg-pid-ra rnd-s mleft-04 psides-04 mtop-01"
}
const _hoisted_29 = { class: "row mtop-25" }
const _hoisted_30 = { class: "menu-col-2" }
const _hoisted_31 = { class: "mtop-20 bg-pid-ra rnd-s psides-04" }
const _hoisted_32 = { class: "w-full h-full content-transparent" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  style: {"width":"59rem"},
  class: "rowcenter"
}
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 1,
  class: "row gap-06 mleft-20"
}
const _hoisted_37 = ["src"]
const _hoisted_38 = ["src"]
const _hoisted_39 = ["src"]
const _hoisted_40 = ["src"]
const _hoisted_41 = ["src"]
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "bg-modal w-maxC" }
const _hoisted_44 = { class: "font-m" }
const _hoisted_45 = { class: "font-m" }
const _hoisted_46 = ["src"]
const _hoisted_47 = {
  key: 0,
  class: "font-mBold main-m"
}
const _hoisted_48 = { class: "font-mBold main-m" }
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "scrollbox mtop-06 w-full col gap-40" }
const _hoisted_51 = {
  key: 0,
  class: "mtop-06"
}
const _hoisted_52 = {
  key: 0,
  class: "colCenter marg-s"
}
const _hoisted_53 = { class: "h4" }
const _hoisted_54 = {
  key: 1,
  class: "colCenter"
}
const _hoisted_55 = {
  key: 0,
  class: "colCenter marg-s w-full"
}
const _hoisted_56 = { class: "h4" }
const _hoisted_57 = {
  key: 1,
  class: "colCenter w-full"
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "row gap-03" }
const _hoisted_60 = { class: "mtop-06" }
const _hoisted_61 = {
  key: 3,
  class: "colCenter w-full"
}

import invoiceCard from './invoiceCard.vue';
import luBillCancellation from './luBillCancellation.vue';
import searchInvoice from './searchInvoice.vue';
import luPid from './luPid.vue';
import doTransaction from './doTransaction.vue'
import patientChange from "@/views/mainMenu/patientChange.vue"
import EsCnsDashboard from '@/components/accounting/esCnsDashboard.vue';
import createReminders from './createReminders.vue'
import financialSummary from './financialSummary.vue';
import createTiersPayant from './createTiersPayant.vue'
import showTiersPayant from './showTiersPayant.vue'

import gen from "@/functions/general.js";
import { ref, computed, onMounted, watch, onBeforeUnmount, nextTick } from 'vue';
import officeapi from "@/api/officeapi";
import patientapi from "@/api/patientapi"
import { useAppUserStore } from '@/stores/appUser'
import {apiDateString, apiDate, apiCurrency} from "@/api/apicommon";
import { usePermissionsStore } from "@/stores/permissionsStore";
import router from '@/router';
import { useRoute } from 'vue-router';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import cnsEconnectorApi from '@/api/cnsEconnectorApi';
import {CnsOperationType} from '@/api/cnsEconnectorApi';
import SharedService from "@/services/SharedService";
import { ApiError, DateFormat } from "@/models/share.model";
import SessionStorageService from '@/services/SessionStorageService';
import { medServerApiConfig } from '@/config/medserver-api.config';
import {useI18n} from "vue-i18n";
import { useToast } from 'primevue';
import { toastError, toastWarn } from '@/utils/toast-utils';
import loadingSpinner from "@/views/loadingSpinner.vue";
import DateService from '@/services/DateService';
import { isBefore, addMinutes, format, addDays, isSameDay } from 'date-fns';
import { pidSimulationTimeout} from '@/api/cnsEconnectorApi';
import { AccountingApi, CNSApi, CnsDashboard, FinancialChannelLightResponse, FinancialGroupLightResponse, FinancialSummaryResponse, InvoiceResponse, PostCreateCnsLogRequest, PostPIDSimulationRequest, TransactionResponse, PersonApi, HealthProResponse, InvoiceSearchItemResponse } from '@/apiGenerate/medserver';
import {extractErrorsFromCnsAnomalie} from '@/api/cnsEconnectorApi';
import { IncomeDirection } from '@/models/accounting.model';

type InvoiceSearchItemWithGroup = (InvoiceSearchItemResponse & { financialGroup: FinancialGroupLightResponse });

const size = 20;

export default /*@__PURE__*/_defineComponent({
  __name: 'dashbAccounting',
  setup(__props) {

const accountingApi = new AccountingApi(medServerApiConfig);

const appUserStore = useAppUserStore();
const permissionsStore = usePermissionsStore();
const route = useRoute();
const currentEntryStore = useCurrentEntryStore();

const summaryData = ref<FinancialSummaryResponse>(null);
let observer: IntersectionObserver = null;
const page = ref<number>(0);
const loading = ref<boolean>(false);
const hasMorePreCompletInvoice = ref<boolean>(true);
const totalPreCompletInvoice = ref<number>(null);
const infiniteScrollTrigger = ref<Element>(null);
const maxInvoices = process.env.VUE_APP_ACCOUNTING_MAX_INVOICES;
const personApi = new PersonApi(medServerApiConfig);

const dropd = ref("");
const {t} = useI18n();
const toast = useToast();

const cnsApi = new CNSApi(medServerApiConfig);

const cnsDashboard = ref<CnsDashboard>({
  nbPidValidated: 0,
  nbPidContested: 0,
  nbMHSent: 0
});
const MockMode = {
  OFF: 'off',
  ECONNECTOR_DISABLED: 'mockEconnectorDisabled',
  ECONNECTOR_NO_PORT: 'mockEconnectorNoPort',
  ECONNECTOR_ERROR: 'mockEconnectorError',
  PID_REFUSED: 'mockPidRefused',
  PID_OK: 'mockPidOk',
} as const;
const mockMode = ref<string>(
  MockMode.OFF
);
const isShowTransmissions = ref(false);
const startDashboard = ref<string>(DateService.getStringFirstDayofMonth(new Date()));
const endDashboard = ref<string>(DateService.getStringLastDayOfMonth(new Date()));

const filterPwrHealthPro = ref<HealthProResponse>(undefined);
const allHealthPro = ref<HealthProResponse[]>([]);
const hasMultipleHealthPro = computed(() => {
  return allHealthPro.value.length > 1;
});

const allCurrChannels = ref<FinancialChannelLightResponse[]>([]);
const currChannel = ref<FinancialChannelLightResponse>(null);
const channelBtnRefs = ref({});

const isPrecompleteChannel = ref(true);
const hasMore = ref(false);
const eConnectorApiError = ref(false);
const precompleteInvoices = ref([]);
const eConnectorActivated = computed(() => {
  if (mockMode.value !== MockMode.OFF) {
    if (mockMode.value === MockMode.ECONNECTOR_DISABLED) return false;
    if (!appUserStore.getCurrentInstituteWithRole().pidActive) return false;
    return true;
  }
  return process.env.VUE_APP_CNS_ECONNECTOR_ACTIVATED && appUserStore.getCurrentInstituteWithRole().pidActive;
});
const simulationAnomalies = ref([]);

const channelTypeOrder = {
  "Cancelled":        1,
  "BankAccount":      2,
  "Cash":             3,
  "BankCard":         4,
  "DigitalPayment":   5,
  "LuTp":             6,
  "LuTpSocial":       7,
  "LuPid":            8,
  "RemainingBalance": 9,
}

const channelTypeAction = {
  "Cancelled":        t('accounting.financialGroupMenu.channelTransactions.cancelled'),
  "BankAccount":      t('accounting.financialGroupMenu.channelTransactions.bankAccount'),
  "Cash":             t('accounting.financialGroupMenu.channelTransactions.cash'),
  "BankCard":         t('accounting.financialGroupMenu.channelTransactions.bankCard'),
  "DigitalPayment":   t('accounting.financialGroupMenu.channelTransactions.digitalPayment'),
  "LuTp":             t('accounting.financialGroupMenu.channelTransactions.luTp'),
  "LuTpSocial":       t('accounting.financialGroupMenu.channelTransactions.luTpSocial'),
  "LuPid":            t('accounting.financialGroupMenu.channelTransactions.luPid'),
  "RemainingBalance": t('accounting.financialGroupMenu.channelTransactions.remainingBalance'),
};

function getChannelActionTerm(channel: FinancialChannelLightResponse) {
  return channelTypeAction[channel?.type] || "";
}

const hasInvoices = computed(() =>
  currChannel.value?.invoiceGroups?.some(g => g?.invoices?.length > 0)
)

const currentPersonId = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return appUserStore.currentAppUserData.healthGroupMemberships[0].pwr.personWithRoleId
});

const singleInvoice = computed(() => {
  return (selectedInvoices.value?.length === 1)
    ? selectedInvoices.value[0]
    : null
})

const currSinglePrecompleteInvoice = computed(() => {
  return (selectedInvoices.value?.length === 1 && selectedInvoices.value[0].invoiceStatus === "Precomplete")
    ? selectedInvoices.value[0]
    : null
})

const currSinglePrecompleteInvoiceHasSimulationError = computed(() => {
  if (!currSinglePrecompleteInvoice.value) return false;
  if (!currSinglePrecompleteInvoice.value?.pwrCounterParty.hasCns) return false;
  if (eConnectorAwaiting.value === true) return false;
  return !currSinglePrecompleteInvoice.value?.patientDocument?.luBillEtransferData?.pidSimulationTimestamp
})

const selectedInvoices = computed(() => {
 return (isPrecompleteChannel.value === true)
    ? precompleteInvoices.value.filter(invoice => invoice.selected)
    : currChannel.value?.invoiceGroups.flatMap(group => group.invoices).filter(invoice => invoice.selected)
})

const selectedStandardInvoices = computed(() => {
  return selectedInvoices.value.filter(inv => ['Standard', 'Reminder'].includes(inv.invoiceType));
})

const selectedInvoicesAmount = computed(() => {
  if (!selectedInvoices.value.length)  return "0";
  let newSum = 0
  selectedInvoices.value.forEach(invoice => {
    newSum += parseFloat(invoice.partial)
  })
  return newSum.toFixed(2) + " " + apiCurrency(selectedInvoices.value[0].currencyIso)
})

function isPidTargetChannel(channel: FinancialChannelLightResponse) {
  const isValidPidSourceChannel = isPrecompleteChannel.value === true;
  if (!isValidPidSourceChannel) return false;
  const targetChannelType = channel.type;
  const isValidPidTargetChannel = ["Cash", "BankCard", "DigitalPayment"].includes(targetChannelType);
  if (!isValidPidTargetChannel) return false;
  const isGroupWithPidChannel = allCurrChannels.value.some(channel => channel.type === "LuPid");
  if (!isGroupWithPidChannel) return false;
  const isSingleSelectedInvoice = selectedInvoices.value?.length === 1;
  if (!isSingleSelectedInvoice) return false;
  const singleSelectedInvoice = selectedInvoices.value[0];
  const isSinglePrecompleteInvoice = singleSelectedInvoice.invoiceStatus === "Precomplete";
  if (!isSinglePrecompleteInvoice) return false;
  const hasCns = singleSelectedInvoice.pwrCounterParty.hasCns;
  if (!hasCns) return false;
  return true;
}

function isDirectTargetChannel(channel: FinancialChannelLightResponse) {
  const sourceChannelType = currChannel.value?.type
  const targetChannelType = channel.type
  if (isPrecompleteChannel.value === true) {return !["LuPid"].includes(targetChannelType)}
  if (sourceChannelType === "RemainingBalance") {
    return !["RemainingBalance", "LuPid"].includes(targetChannelType)
  }
  if (targetChannelType === "Cancelled") {
    if (selectedInvoices.value.length > 1) return false;
    return ["RemainingBalance", "LuPid", "BankCard", "DigitalPayment", "Cash"].includes(sourceChannelType);
  }
  if (["BankCard", "DigitalPayment", "LuPid", "LuTp", "LuTpSocial"].includes(sourceChannelType)) {return ["BankAccount"].includes(targetChannelType)}
  return false
}

async function checkPermission() {
  const hasAccess = await permissionsStore.checkPermission("ACCESS_ACCOUNTING");

  if (!hasAccess) {
      router.push('/error?error=USER_FORBIDDEN');
  }
}

function compareOnChannel(a: FinancialChannelLightResponse, b: FinancialChannelLightResponse) {
  const typeA = channelTypeOrder[a.type]
  const typeB = channelTypeOrder[b.type]
  if (typeA && typeB) {
      return typeA - typeB
  }
  return -1
}

function switchChannel(channel: FinancialChannelLightResponse) {
  filterRefNumber.value = "";
  isRefPillMode.value = false;
  setCustomChannel(channel);
  getInvoicesByFinancialGroup();
}

function setCustomChannel(channel: FinancialChannelLightResponse) {
  isPrecompleteChannel.value = false;
  currChannel.value = channel;
  isShowTransmissions.value = false;
}

async function changeFinancialGroup(financialGroup: FinancialGroupLightResponse) {
  dropd.value = "";
  filterRefNumber.value = "";
  isRefPillMode.value = false;
  currFinancialGroup.value = financialGroup;
  await getFinancialGroup(financialGroup, null);
  if (allCurrChannels.value?.length) {
    setCustomChannel(allCurrChannels.value.at(-1));
  }
  isShowTransmissions.value = false;
}

function resolveTargetChannel(invoice: InvoiceSearchItemWithGroup) {
  if (invoice.invoiceStatus === 'Precomplete') return null;
  if (invoice.channelId == null) {
    return allCurrChannels.value.find(c => c.type === 'RemainingBalance');
  }
  return allCurrChannels.value.find(c => c.id === invoice.channelId);
}

async function onSearchInvoiceClicked(invoice: InvoiceSearchItemWithGroup) {
  dropd.value = "";
  filterRefNumber.value = invoice.invoiceReference;
  isRefPillMode.value = true;
  // FinancialGroup
  const targetGroup = allFinancialGroups.value.find(g => g.id === invoice.financialGroup.id);
  if (!targetGroup) return;
  if (targetGroup.id !== currFinancialGroup.value?.id) {
    currFinancialGroup.value = targetGroup;
    [allCurrChannels.value, allHealthPro.value] = await Promise.all([
      accountingApi.getChannelsByFinancialGroup({ financialGroupId: targetGroup.id }),
      accountingApi.getHealthProByFinancialGroup({ financialGroupId: targetGroup.id })
    ]);
  }
  // Align currChannel BEFORE fetching so the API query uses the correct channel
  currChannel.value = resolveTargetChannel(invoice) ?? null;
  await getInvoicesByFinancialGroup({ ignoreAllFilters: true });
  // Re-resolve AFTER fetchingto avoid stale references to channels
  if (invoice.invoiceStatus === 'Precomplete') {
    setPrecompleteChannel();
  } else {
    const freshChannel = resolveTargetChannel(invoice);
    if (freshChannel) {
      setCustomChannel(freshChannel);
      freshChannel.invoiceGroups[0]?.invoices[0] && (freshChannel.invoiceGroups[0].invoices[0].selected = true);
    }
  }
}

async function navigateToFinancialGroup() {
  isNavigating.value = true;
  //Called from middleDocument with
  //    query: { financialGroupId, targetChannelId, invoiceRef }

  // or called from dashbInvoiceHistory with
  //    query: { financialGroupId, channelId, channelType, patientId, invoiceRef }

  try {
    const { financialGroupId, channelId, targetChannelId, channelType, invoiceRef } = route.query;
    router.replace({ query: {} });

    if (!financialGroupId) return;
    const targetGroup = allFinancialGroups.value.find(g => g.id === Number(financialGroupId));
    if (!targetGroup) return;

    if (invoiceRef) {
      filterEndDate.value = null;
      filterStartDate.value = null;
      filterRefNumber.value = invoiceRef as string;
      isRefPillMode.value = true;
    }

    //Fetch
    currFinancialGroup.value = targetGroup;  
    currChannel.value = null;
    
    await getFinancialGroup(targetGroup, channelId ? Number(channelId) : null);

    // If from middleDocument (invoice lives in precomplete; targetChannelId is the move destination)
    if (targetChannelId) {
      setPrecompleteChannel();
      return;
    }

    //Switch to channel
    if (channelType === 'RemainingBalance') {
      const rbChannel = allCurrChannels.value.find(c => c.type === 'RemainingBalance');
      if (rbChannel) {
        setCustomChannel(rbChannel);
        rbChannel.invoiceGroups[0]?.invoices[0] && (rbChannel.invoiceGroups[0].invoices[0].selected = true);
      }
    } else if (channelId) {
      const targetChannel = allCurrChannels.value.find(c => c.id === Number(channelId));
      if (targetChannel) {
        setCustomChannel(targetChannel);
        targetChannel.invoiceGroups[0]?.invoices[0] && (targetChannel.invoiceGroups[0].invoices[0].selected = true);
      }
    } else {
      setPrecompleteChannel();
    }
  } finally {
    isNavigating.value = false;
  }
}

function onPrecompleteClicked() {
  filterRefNumber.value = "";
  isRefPillMode.value = false;
  setPrecompleteChannel();
}

function setPrecompleteChannel() {
  isFirstLoad.value = true;
  precompleteInvoices.value = [];
  page.value = 0;
  hasMorePreCompletInvoice.value = true;
  loading.value = false;
  isPrecompleteChannel.value = true;
  currChannel.value = null;
  isShowTransmissions.value = false;
  loadMoreInvoices();
}

const getFinancialGroupLightResponseFromInvoice = (invoice: InvoiceResponse): FinancialGroupLightResponse => {
  return allFinancialGroups.value.filter((group: FinancialGroupLightResponse) => group.id === invoice.financialGroup.id)[0];
}

function ctaClicked(invoice: InvoiceResponse) {
  if (invoice.invoiceStatus !== "Precomplete") return;
  if (!invoice.selected) return;

  const currInvoiceId = invoice.id;
  precompleteInvoices.value.forEach(invoice => {
    if (invoice.selected && invoice.id !== currInvoiceId) {
      invoice.selected = false
    }
  })

  const financialGroup: FinancialGroupLightResponse = getFinancialGroupLightResponseFromInvoice(invoice); 

  if (financialGroup.id === currFinancialGroup.value.id) {
    if (isPrecompleteChannel.value === true && allCurrChannels.value.some(channel => channel.type === "LuPid")) {
      const pidInvoice = selectedInvoices.value[0];
      autoProceedPidSimulation(pidInvoice);
    }
    return;
  }

  currFinancialGroup.value = financialGroup;
  getFinancialGroup(financialGroup, null);
}

function createChannel(financialChannelType: string, channelTitle: string, financialChannelId: number) {
  return {
    "id" : financialChannelId,
    "type" : financialChannelType,
    "title" : channelTitle,
    "invoiceGroups" : [],
    "count" : 0,
    "active": true,
    "total" : 0.00,
  }
}

let portDiscoveryPromise: Promise<void> | null = null;

function discoverCnsEconnectorApiPort() {
  portDiscoveryPromise = _discoverCnsEconnectorApiPort();
  return portDiscoveryPromise;
}

async function _discoverCnsEconnectorApiPort() {
  // MOCK
  if (mockMode.value === MockMode.ECONNECTOR_NO_PORT) {
    eConnectorApiError.value = true;
    return;
  }
  if (mockMode.value !== MockMode.OFF) {
    eConnectorApiError.value = false;
    return;
  }
  // REAL
  if (!eConnectorActivated.value) return;

  const ports = ['16900', '16901', '16902'];
  for (const port of ports) {
    try {
      const response = await cnsEconnectorApi.status(port);
      if (response.ok) {
        SessionStorageService.setItem('cnsEconnectorApiPort', port);
        eConnectorApiError.value = false;
        return;
      }
    } catch {
      // Port unavailable, try next
    }
  }
  eConnectorApiError.value = true;
}

function isForNewPidSimulation(invoice: InvoiceResponse) {
  if (!invoice) return false;
  if (invoice.invoiceStatus !== "Precomplete") return false;
  if (!invoice.pwrCounterParty.hasCns) return false;  
  const lastTimestamp = invoice.patientDocument?.luBillEtransferData?.pidSimulationTimestamp
  if (!lastTimestamp) return true;
  const timeSinceLastSimulation = Date.now() - new Date(lastTimestamp).getTime();
  // Trigger new simulation 1 minute before actual expiration (pidSimulationTimeout = 10min)
  // This gives users time to complete their action before the simulation expires
  const THRESHOLD_MINUTES = 9;
  const thresholdMs = THRESHOLD_MINUTES * 60 * 1000;
  return timeSinceLastSimulation > thresholdMs;
}

function autoProceedPidSimulation(invoice: InvoiceResponse) {
  if (!invoice) return;
  if (!invoice.pwrCounterParty.hasCns) return;
  if (!isForNewPidSimulation(invoice)) return;
  if (invoice.patientDocument?.luBillEtransferData?.pidContestationTimestamp) return;
  proceedPidSimulation(invoice);
}

async function redoPidSimulation(invoice: InvoiceResponse, targetFinancialChannel: FinancialChannelLightResponse) {
  dropd.value = "";
  await proceedPidSimulation(invoice);
  dropd.value = "PidRa" + targetFinancialChannel.id;
}

// eConnector
const eConnectorAwaiting = ref(false);
function hasNonExpiredSimulation(invoice: InvoiceResponse): boolean {
  const pidSimulationTimestamp = invoice?.patientDocument?.luBillEtransferData?.pidSimulationTimestamp;
  if (!pidSimulationTimestamp) return false;
  const expirationDate = addMinutes(new Date(pidSimulationTimestamp), pidSimulationTimeout);
  const now = new Date();
  return isBefore(now, expirationDate);
}

async function callEconnectorPidSimulation(invoiceId: number) {
  // MOCK
  if (mockMode.value !== MockMode.OFF) {
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    if (mockMode.value === MockMode.ECONNECTOR_ERROR) {
      return { success: false, errorDetails: '- Mock: PID Simulation failed' };
    }
    
    const invoice = precompleteInvoices.value.find(inv => inv.id === invoiceId);
    const totalAmount = invoice?.amount || 0;
    const cnsAmount = (totalAmount * 0.88).toFixed(2);
    const patientAmount = (totalAmount * 0.12).toFixed(2);
    
    if (mockMode.value === MockMode.PID_REFUSED) {
      return {
        success: true,
        cnsAmount: "0",
        patientAmount: "0",
        cnsAuthorizationUuid: null,
        cnsAuthorizationNumber: null,
        errors: [
          { id: "ERR_001", description: "C38 déjà facturé" },
          { id: "ERR_002", description: "Montant dimanche facturé en semaine" }
        ]
      };
    }
    
    // MockMode.PID_OK or other mock modes
    return {
      success: true,
      cnsAmount,
      patientAmount,
      cnsAuthorizationUuid: crypto.randomUUID(),
      cnsAuthorizationNumber: Math.random().toString(36).substring(2, 17).toUpperCase(),
      errors: []
    };
  }

  // REAL
  const port = SessionStorageService.getItem('cnsEconnectorApiPort');
  const pidSimulationRequest: PostPIDSimulationRequest = { pidSimulationRequest: { invoiceId: invoiceId } };
  const pidSimulationResponse = await cnsApi.postPIDSimulation(pidSimulationRequest);

  const cnsResponse = await cnsEconnectorApi.createSimulation(port, pidSimulationResponse.gpCode, pidSimulationResponse.xmlRequest);
  const errorsMap = extractErrorsFromCnsAnomalie(cnsResponse.utaretour.anomalies);
  cnsResponse.utaretour.lignes.ligneUTARetour.forEach((ligne) => {
    extractErrorsFromCnsAnomalie(ligne.anomalies).forEach((value, key) => {
      errorsMap.set(key, value);
    });
  });

  const errors = Array.from(errorsMap.entries()).map(([id, description]) => ({ id, description }));

  const cnsLogRequest: PostCreateCnsLogRequest = {
    cnsLogRequest: {
      operationType: CnsOperationType.PID_REQUEST_SIMULATION.toString(),
      requestContent: pidSimulationResponse.xmlRequest,
      responseContent: JSON.stringify(cnsResponse),
      status: errors.length > 0 ? 'NOK' : 'OK',
      timestamp: new Date(),
      financialGroupId: currFinancialGroup.value.id
    }
  };
  await cnsApi.postCreateCnsLog(cnsLogRequest);

  return {
    success: true,
    cnsAmount: cnsResponse.utaretour.totalPartStatutaire.toString(),
    patientAmount: cnsResponse.utaretour.totalParticipationPersonelle.toString(),
    cnsAuthorizationUuid: cnsResponse.utaretour.identifiantReponseSimulation,
    cnsAuthorizationNumber: cnsResponse.utaretour.matricule.toString(),
    errors
  };
}

async function proceedPidSimulation(invoice: InvoiceResponse) {
  if (!eConnectorActivated.value) return;
  if (portDiscoveryPromise) await portDiscoveryPromise
  if (invoice.invoiceStatus !== "Precomplete") { console.log("Error. Only valid for 'precomplete' invoices"); return; }
  if (!invoice.pwrCounterParty.hasCns) { console.log("Patient has no PID -> no simulation"); return; }
  const luBillEtransferData = invoice.patientDocument?.luBillEtransferData;
  if (luBillEtransferData?.pidValidationTimestamp) { console.log("Already validated as PID"); return; }
  if (luBillEtransferData?.raValidationTimestamp) { console.log("Already validated as RA"); return; }
  if (luBillEtransferData?.raCancellationTimestamp) { console.log("Already cancelled"); return; }
  if (hasNonExpiredSimulation(invoice)) {
    toastError(toast, {
      summary: t('accounting.econnector.pidSimulation.toast.stillValid'),
      life: 5000
    });
    return;
  }
  if (eConnectorApiError.value) { console.log("eConnector needed but not available"); return; }
  const invoiceId = invoice.id;
  if (eConnectorAwaiting.value) return;
  eConnectorAwaiting.value = true;
  try {
    const eConnectorResult = await callEconnectorPidSimulation(invoiceId);
    if (!eConnectorResult.success) {
      toastError(toast, {
        summary: t('accounting.econnector.pidSimulation.toast.error'),
        detail: eConnectorResult.errorDetails
          ? t('accounting.econnector.pidSimulation.toast.errorWithDetails', { details: '\n' + eConnectorResult.errorDetails })
          : t('accounting.econnector.service.technicalError'),
        life: 5000
      });
      return;
    }
    // Update anomalies
    simulationAnomalies.value = eConnectorResult.errors;
    invoice.simulationError = eConnectorResult.errors.length > 0;

    // Show toast if errors
    if (invoice.simulationError) {
      const errorDetails = eConnectorResult.errors.map(e => '- ' + e.description).join('\n');
      toastError(toast, {
        summary: t('accounting.econnector.pidSimulation.toast.refused'),
        detail: errorDetails,
        life: 5000
      });
    } else {
      // Backend
      const simulationTimestamp = new Date();
      const newLuBillEtransferData = await patientapi.addPidSimulationToEtransferData(
        invoice.id.toString(),
        eConnectorResult.patientAmount,
        eConnectorResult.cnsAmount,
        eConnectorResult.cnsAuthorizationUuid,
        eConnectorResult.cnsAuthorizationNumber,
        simulationTimestamp
      );
      invoice.patientDocument.luBillEtransferData = newLuBillEtransferData;
    }
  } catch (error) {
    toastError(toast, {
      summary: t('accounting.econnector.pidSimulation.toast.error'),
      detail: t('accounting.econnector.service.unspecifiedError'),
      life: 5000
    });
  } finally {
    eConnectorAwaiting.value = false;
  }
}

function getCnsStatus(invoice: InvoiceResponse) {
  const luBillEtransferData = invoice.patientDocument?.luBillEtransferData;
  if (luBillEtransferData?.raCancellationTimestamp) {return "raCancellation";}
  if (luBillEtransferData?.raValidationTimestamp) {return "raValidation";}
  if (luBillEtransferData?.pidValidationTimestamp) {return "pidValidation";}
  if (luBillEtransferData?.pidContestationTimestamp) {return "pidContestation";}
  if (luBillEtransferData?.pidSimulationTimestamp) {return "pidSimulation";}
  if (!luBillEtransferData) {return "emptyCns";}
  return "uknown";
}

function pushCopiedInvoice(invoiceGroup, invoice, partial, currTransactionId, total=invoice.amount) {
  invoice = gen.deepCopy(invoice);
  invoice.selected = false;
  invoice.partial = partial;
  invoice.total = total;
  invoice.currTransactionId = currTransactionId;

  if (invoiceGroup.invoices.findIndex((itemInvoice) => itemInvoice.id === invoice.id) === -1) {
    invoiceGroup.invoices.push(invoice);
  }
}

let precompleteRequestId = 0;

async function fetchPrecompleteInvoices() {
  if (!currentPersonId.value) {allFinancialGroups.value = []; return;}
  const requestId = ++precompleteRequestId;
  const invoiceRef = isRefPillMode.value ? filterRefNumber.value : undefined;
  const allPrecompleteInvoices = await officeapi.getAllPrecompleteInvoices(currentPersonId.value, page.value, size, invoiceRef)
  if (requestId !== precompleteRequestId) return;
  totalPreCompletInvoice.value = allPrecompleteInvoices.totalElements;
  hasMorePreCompletInvoice.value = !allPrecompleteInvoices.last
  const ret = allPrecompleteInvoices.content
    .map(invoice => ({
      ...invoice,
      selected: false,
      partial: invoice.remainingBalance,
      simulationError: false
    }))
    precompleteInvoices.value.push(...ret)
    return ret;
}

function focusFirstPrecompleteInvoice() {
  const toSelect = precompleteInvoices.value?.[0];
  if (!toSelect) return;
  toSelect.selected = true;
  const financialGroupSelected = getFinancialGroupLightResponseFromInvoice(toSelect) ?? allFinancialGroups.value[0];
  currFinancialGroup.value = financialGroupSelected;
  getFinancialGroup(financialGroupSelected, null);
}

const isNavigating = ref(false);
const isFirstLoad = ref(true);



async function loadMoreInvoices() {
  if (loading.value || !hasMorePreCompletInvoice.value || !currentPersonId.value) return
  loading.value = true
  try {
    await fetchPrecompleteInvoices()
    page.value++;
    if (isFirstLoad.value) {
      isFirstLoad.value = false;
      focusFirstPrecompleteInvoice();
    }
  } finally {
    loading.value = false
  }
}

function createInvoiceGroup(text) {
  return {
    "text": text,
    "invoices": []
  }
}

function createDatedInvoiceGroup(dateIso) {
  return {
    "date": apiDate(dateIso),
    "text": apiDateString(dateIso),
    "invoices": []
  }
}

function initChannel(channel: FinancialChannelLightResponse) {
  channel.invoiceGroups = [];
  channel.count = 0;
  channel.total = 0.00;
  return channel;
}

const isRefPillMode = ref(false);

function clearFilterRefNumber() {
  filterRefNumber.value = "";
  isRefPillMode.value = false;
  if (isPrecompleteChannel.value) {
    setPrecompleteChannel();
  } else {
    getInvoicesByFinancialGroup();
  }
}

function isDateInRange(dateString: string | null) {
  if (isRefPillMode.value) return true;
  if (!dateString) return false;
  const date = new Date(dateString.split('T')[0]);
  const startDate = filterStartDate.value ? new Date(filterStartDate.value) : null;
  const endDate = filterEndDate.value ? new Date(filterEndDate.value) : null;
  if (startDate) startDate.setHours(0, 0, 0, 0);
  if (endDate) endDate.setHours(23, 59, 59, 999);
  if (startDate && date < startDate) return false;
  if (endDate && date > endDate) return false;
  return true;
}

function addToDateGroup(channel, invoice, amount, transaction, total = null) {
  const dateKey = transaction.transactionDateTime.split(' ')[0];
  let group = channel.invoiceGroups.find(g => g.key === dateKey);

  if (!group) {
    group = createDatedInvoiceGroup(transaction.transactionDateTime);
    group.key = dateKey;
    channel.invoiceGroups.push(group);
  }

  pushCopiedInvoice(group, invoice, amount, transaction.transactionId, total);
  channel.count += 1;
  channel.total += parseFloat(amount);
}

function addToTpGroups(channel, invoice, amount, transaction, tpArray) {
  // No TP - "Not submitted" group
  if (!tpArray || tpArray.length === 0) {
    let group = channel.invoiceGroups.find(g => g.key === 'notSubmitted');
    if (!group) {
      group = createInvoiceGroup(t('accounting.financialGroupMenu.fixGroups.notSubmitted'));
      group.key = 'notSubmitted';
      group.date = new Date(9999, 11, 31);
      channel.invoiceGroups.push(group);
    }
    pushCopiedInvoice(group, invoice, amount, transaction.transactionId);
    channel.count += 1;
    channel.total += parseFloat(amount);
    return;
  }

  // Group by each TP date
  tpArray.forEach((tp) => {
    const tpKey = tp.uuid;
    let group = channel.invoiceGroups.find(g => g.key === tpKey);

    if (!group) {
      group = {
        date: apiDate(tp.tpCreationTimestamp),
        text: t('accounting.financialGroupMenu.fixGroups.tpCreatedOn', {date: apiDateString(tp.tpCreationTimestamp)}),
        key: tpKey,
        invoices: []
      };
      channel.invoiceGroups.push(group);
    }

    pushCopiedInvoice(group, invoice, amount, transaction.transactionId);
    channel.count += 1;
    channel.total += parseFloat(amount);
  });
}

function sortChannels(channels) {
  channels
    .sort((a: FinancialChannelLightResponse, b: FinancialChannelLightResponse) => compareOnChannel(a, b) || a.title.localeCompare(b.title))
    .forEach((channel: FinancialChannelLightResponse) => {
      if (channel.type === 'RemainingBalance') {
        channel.invoiceGroups.sort((a, b) => {
          // Keep the default (no date) group first
          if (!a.date && !b.date) return 0;
          if (!a.date) return -1;
          if (!b.date) return 1;
          return b.date - a.date;
        });
      } else {
        channel.invoiceGroups.sort((a, b) => b.date - a.date);
      }
      channel.invoiceGroups.forEach((group) => {
        group.invoices?.sort((a, b) => new Date(b.created) - new Date(a.created));
      });
    });
}

function createIncomeLists() {
  if (!allCurrChannels.value) return;

  const channels: FinancialChannelLightResponse[] = gen.deepCopy(allCurrChannels.value);
  const invoices: InvoiceResponse[] = gen.deepCopy(invoicesIncoming.value);

  // Initialize channels
  const channelLookup = {};
  channels.forEach((channel) => {
    initChannel(channel);
    channelLookup[channel.id] = channel;
  });

  // Create RemainingBalance channel
  let unpaidChannel = channels.find(c => c.type === 'RemainingBalance');
  if (!unpaidChannel) {
    unpaidChannel = createChannel('RemainingBalance', t('accounting.financialGroupMenu.fixChannels.remainingBalance'), 0);
    channels.push(unpaidChannel);
  }
  // Default group for invoices without a reminderGroup
  const unpaidGroup = createInvoiceGroup(t('accounting.financialGroupMenu.fixChannels.remainingBalance'));
  unpaidChannel.invoiceGroups.push(unpaidGroup);
  // Lookup for reminder-date-based groups
  const reminderGroupLookup = {};

  // Process invoices
  invoices.forEach((invoice: InvoiceResponse) => {
    if (invoice.invoiceStatus === "Precomplete") return;

    // RemainingBalance — no date check, API already filtered at invoice level
    if (invoice.remainingBalance && invoice.remainingBalance !== "0.00") {
      let targetGroup;
      if (invoice.latestReminderGroup) {
        // Group by reminderDateTime date + allOutstanding
        const reminderGroup = invoice.latestReminderGroup;
        const reminderGroupKey = reminderGroup.reminderDateTime + (reminderGroup.allOutstanding ? '-ok' : '-stale');   // split into two buckets
        if (!reminderGroupLookup[reminderGroupKey]) {
          reminderGroupLookup[reminderGroupKey] = createDatedInvoiceGroup(reminderGroup.reminderDateTime);  // clean date, NOT the suffixed key
          reminderGroupLookup[reminderGroupKey].text += reminderGroup.allOutstanding
            ? ' - ' + t('accounting.invoiceReminder.reminders')
            : ' - ' + t('accounting.invoiceReminder.remindersWithSettled');
          reminderGroupLookup[reminderGroupKey].reprintable = reminderGroup.allOutstanding;      // bucket-level flag for print gating
          unpaidChannel.invoiceGroups.push(reminderGroupLookup[reminderGroupKey]);
        }
        targetGroup = reminderGroupLookup[reminderGroupKey];
      } else {
        targetGroup = unpaidGroup;
      }
      pushCopiedInvoice(targetGroup, invoice, invoice.remainingBalance, "");
      unpaidChannel.count += 1;
      unpaidChannel.total += parseFloat(invoice.remainingBalance);
    }

    // Transactions
    invoice.transactions.forEach((transaction) => {
      if (!isDateInRange(transaction.transactionDateTime)) return;

      const channel = channelLookup[transaction.financialChannelId];
      if (!channel) return;

      const total = sumTransactionsByChannelId(transaction, invoice.secondaryTransactions);
      const remaining = channelRemainingByChannelId(transaction, invoice.secondaryTransactions);

      if (channel.isThirdPartyChannel && remaining === "0.00") return;

      // TP channels - group by tpCreationTimestamp
      if (channel.type === 'LuTp') {
        addToTpGroups(channel, invoice, remaining, transaction, invoice.tiersPayants);
      } else if (channel.type === 'LuTpSocial') {
        addToTpGroups(channel, invoice, remaining, transaction, invoice.tiersPayantSocials);
      } else {
        // Normal channels - group by transaction date
        addToDateGroup(channel, invoice, remaining, transaction, total);
      }
    });

    // Secondary transactions
    invoice.secondaryTransactions.forEach((transaction) => {
      if (!isDateInRange(transaction.transactionDateTime)) return;

      const channel = channelLookup[transaction.financialChannelId];
      if (!channel || channel.type === 'LuTp' || channel.type === 'LuTpSocial') return;

      addToDateGroup(channel, invoice, transaction.amount, transaction);
    });
  });

  // Sort
  sortChannels(channels);

  allCurrChannels.value = channels;
}

function sumTransactionsByChannelId(transaction: any, secondaryTransactions: any) {
  const targetChannelId = transaction.financialChannelId;
  const total = secondaryTransactions
    .filter((transaction: TransactionResponse) => transaction.sourceFinancialChannelId === targetChannelId)
    .reduce((sum: number, transaction: TransactionResponse) => sum + parseFloat(transaction.amount || '0'), 0)
  return total.toFixed(2)
}

function channelRemainingByChannelId(transaction: any, secondaryTransactions: any) {
  const targetChannelId = transaction.financialChannelId;
  const total = secondaryTransactions
    .filter((transaction: TransactionResponse) => transaction.sourceFinancialChannelId === targetChannelId)
    .reduce((sum: number, transaction: TransactionResponse) => sum + parseFloat(transaction.amount || '0'), 0)
  const remaining = parseFloat(transaction.amount) - total
  return remaining.toFixed(2)
}

const allFinancialGroups = ref<FinancialGroupLightResponse[]>([])
const currFinancialGroup = ref<FinancialGroupLightResponse>(null)
const invoicesIncoming = ref<InvoiceResponse[]>([]);

const getAllFinancialGroups = async () => {
    await personApi.findFinancialGroupsForPerson({ personId: currentPersonId.value }).then((result: FinancialGroupLightResponse[]) => {
        allFinancialGroups.value = result;
    }).catch((error: ApiError) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
        });
    });
}

let abortController: AbortController = null;

async function getFinancialGroup(financialGroup: FinancialGroupLightResponse, targetChannelId : number) {
  if (financialGroup && financialGroup.id) {
    abortController?.abort();
    abortController = new AbortController();
    const signal = abortController.signal;
    invoicesIncoming.value = [];
    try {
      [allCurrChannels.value, allHealthPro.value, invoicesIncoming.value, summaryData.value] = await Promise.all([
        accountingApi.getChannelsByFinancialGroup({ financialGroupId: financialGroup.id, filterByActive: false, filterInvoice: true }, { signal }),
        accountingApi.getHealthProByFinancialGroup({ financialGroupId: financialGroup.id }, { signal }),
        accountingApi.getInvoicesByFinancialGroup({
          financialGroupId: financialGroup.id,
          financialChannelId: targetChannelId ?  targetChannelId : (!currChannel.value || currChannel.value.type === 'RemainingBalance') ? null : currChannel.value.id,
          direction: IncomeDirection.Income,
          invoiceRef: filterRefNumber.value ?? null,
          startDate: filterStartDate.value ? format(filterStartDate.value, DateFormat.ISO_SMALL) : "",
          endDate: filterEndDate.value ? format(addDays(filterEndDate.value, 1), DateFormat.ISO_SMALL) : ""
        }, { signal }),
        accountingApi.getFinancialSummary({
          financialGroupId: financialGroup.id,
          patientId: filterPwrPatient.value?.patientId ?? null,
          healthProId: filterPwrHealthPro.value?.id ?? null,
          startDate: filterStartDate.value ? format(filterStartDate.value, DateFormat.ISO_SMALL) : "",
          endDate: filterEndDate.value ? format(addDays(filterEndDate.value, 1), DateFormat.ISO_SMALL) : ""
        }, { signal })
      ]);
      hasMore.value = invoicesIncoming.value.length > maxInvoices;
    } catch (error: ApiError) {
      if (signal.aborted) return;
      toastError(toast, {
        summary: t('common.toast.error'),
        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });
      return;
    }

    createIncomeLists();
    if (isPrecompleteChannel.value === true && allCurrChannels.value.some(channel => channel.type === "LuPid")) {
      const pidInvoice = selectedInvoices.value[0];
      autoProceedPidSimulation(pidInvoice);
    }
  }
}

async function getInvoicesByFinancialGroup({ ignoreAllFilters = false } = {}) {
  abortController?.abort();
  abortController = new AbortController();
  const signal = abortController.signal;

  invoicesIncoming.value = [];
  loading.value = true;
  const skipDates = !!filterRefNumber.value || ignoreAllFilters;
  try {
    const [invoices, summary] = await Promise.all([
      accountingApi.getInvoicesByFinancialGroup({
        financialGroupId: currFinancialGroup.value.id,
        financialChannelId: (!currChannel.value || currChannel.value.type === 'RemainingBalance') ? null : currChannel.value.id,
        direction: IncomeDirection.Income,
        patientId: ignoreAllFilters ? null : filterPwrPatient.value?.patientId ?? null,
        healthProId: ignoreAllFilters ? null : filterPwrHealthPro.value?.id ?? null,
        invoiceRef: filterRefNumber.value ?? null,
        startDate: !skipDates && filterStartDate.value ? format(filterStartDate.value, DateFormat.ISO_SMALL) : "",
        endDate: !skipDates && filterEndDate.value ? format(addDays(filterEndDate.value, 1), DateFormat.ISO_SMALL) : ""
      }, { signal }),
      accountingApi.getFinancialSummary({
        financialGroupId: currFinancialGroup.value.id,
        patientId: ignoreAllFilters ? null : filterPwrPatient.value?.patientId ?? null,
        healthProId: ignoreAllFilters ? null : filterPwrHealthPro.value?.id ?? null,
        startDate: !skipDates && filterStartDate.value ? format(filterStartDate.value, DateFormat.ISO_SMALL) : "",
        endDate: !skipDates && filterEndDate.value ? format(addDays(filterEndDate.value, 1), DateFormat.ISO_SMALL) : ""
      }, { signal })
    ]);
    invoicesIncoming.value = invoices;
    summaryData.value = summary;
    hasMore.value = invoices.length > maxInvoices;
  } catch (error: ApiError) {
    if (signal.aborted) return;
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
    return;
  } finally {
    loading.value = false;
  }
  reloadAfterFilter();
}

async function initialize() {
  isFirstLoad.value = true;
  allFinancialGroups.value = [];
  currFinancialGroup.value = null;
  if (!currentPersonId.value) return;
  await getAllFinancialGroups();
  if (!allFinancialGroups.value.length) return;
  discoverCnsEconnectorApiPort();
  appUserStore.setRefreshAccounting(false);
  const hasFinancialGroupParam = !!route.query.financialGroupId;
  if (hasFinancialGroupParam) {
    await navigateToFinancialGroup();
  } else {
    currFinancialGroup.value = allFinancialGroups.value[0];
    getFinancialGroup(allFinancialGroups.value[0], null);
  }
}

function addTransactionsBtn(targetFinancialChannel: FinancialChannelLightResponse) {
  const targetFinancialChanneType = targetFinancialChannel.type
  if (targetFinancialChanneType === "Cancelled") {
    if (!singleInvoice.value) {console.log("Error. Cancellation should only be avaible for single transactions"); return;}
    dropd.value = "Cancel" + targetFinancialChannel.id;
    return;
  }  

  if (isPrecompleteChannel.value === true) {
    if (!currSinglePrecompleteInvoice.value) {console.log("Error. Cancellation should only be avaible for single precomplete invoice"); return;}
    dropd.value = "PidRa" + targetFinancialChannel.id;
    return;
  }

  dropd.value = "DoTransaction" + targetFinancialChannel.id;
}

function reloadAndSwitch(targetFinancialChannel: any) {
  setCustomChannel(targetFinancialChannel);
  reload();
}

async function reload() {
  dropd.value = "";
  const financialChannelId = currChannel.value?.id;
  await getFinancialGroup(currFinancialGroup.value, null);
  if (isPrecompleteChannel.value !== true) {
    currChannel.value = allCurrChannels.value.find(channel => channel.id === financialChannelId);
  }
  // Reset precomplete state before fetching
  precompleteInvoices.value = [];
  page.value = 0;
  hasMorePreCompletInvoice.value = true;
  await loadMoreInvoices();
}

function selectAll(invoiceGroup: any) {
  const allSelected = invoiceGroup.invoices.every(item => item.selected)
  invoiceGroup.invoices.forEach(item => item.selected = !allSelected)
}

const invoicesPdfBlob = ref(null)
const isLoading = ref(false)

async function fetchAndPrint(invoices, fetcher) {
  const invoiceIds = invoices.map(inv => inv.id);
  if (!invoiceIds.length) return;
  dropd.value = "";
  isLoading.value = true;
  try {
    const respBlob = await fetcher(invoiceIds);
    if (!respBlob) return;
    invoicesPdfBlob.value = respBlob;
    gen.printBlob(respBlob, "Pdf");
  } finally {
    isLoading.value = false;
  }
}

function printSelected() {
  return fetchAndPrint(selectedInvoices.value, ids => officeapi.getInvoicesPdfStream(ids));
}

function printSelectedWithReminders() {
  const printable = selectedInvoices.value.filter(
    inv => !inv.latestReminderGroup || inv.latestReminderGroup.allOutstanding
  );
  const excluded = selectedInvoices.value.length - printable.length;
  if (excluded) {
    toastWarn(toast, {
      summary: t('common.info'),
      detail: t('accounting.invoiceReminder.remindersNotPrinted', { count: excluded }),
    });
  }
  return fetchAndPrint(printable, ids => officeapi.getInvoicesWithRemindersPdfStream(ids));
}

const hasSelectionReprintable = computed(() =>
  selectedInvoices.value.some(i => i.latestReminderGroup?.allOutstanding)
);

const API_METHOD_MAP = {
  transactions: 'getTransactionListCsv',
  luBilledActs: 'createLuBilledActListCsv',
  luBills: 'createLuBillListCsv',
  exportForBob50: 'exportForBob50'
};

async function getCsv(listType: string) {
  dropd.value = '';
  const financialGroupId = currFinancialGroup.value?.id;
  if (!financialGroupId) {console.log("No financialGroupId"); return;}
  const apiMethod = API_METHOD_MAP[listType];
  if (!apiMethod) {console.log("Error. Unknown list-type to export."); return;}
  const resp = await officeapi[apiMethod](financialGroupId);
  if (!resp) {console.log("No data from backend"); return;}
  const blob = await resp.blob();
  const headerFilename = gen.extractFilenameFromHeaders(resp.headers);
  const fileName = headerFilename?.fileName || "export";
  const fileExtension = headerFilename?.fileExtension || "csv";
  gen.downloadBlob(blob, fileName, fileExtension);
}
const filterRefNumber = ref("");

watch(dropd, () => {
  if (dropd.value === "" && doReladAfterDate.value) {
    doReladAfterDate.value = false;
    reload();
  }
})

const filterPwrPatient = ref(null);
function changeFilterPwrPatient(pwr: any) {
  filterPwrPatient.value = pwr;
  getInvoicesByFinancialGroup();
}

function changeFilterPwrHealthPro(pwr: HealthProResponse) {
  filterPwrHealthPro.value = pwr;
  getInvoicesByFinancialGroup();
}

function reloadAfterFilter() {
  dropd.value = '';
  createIncomeLists();
  const financialChannelId = currChannel.value?.id;
  currChannel.value = allCurrChannels.value.find(channel => channel.id === financialChannelId);
}

const filterStartDate = ref<Date>(new Date());
const filterEndDate = ref<Date>(new Date());
const doReladAfterDate = ref(false);

const changeFilterDate = (newDate) => {
  const tempStartDate = newDate[0];
  const tempEndDate = newDate[1];
  if (!tempEndDate) return;
  ///Update
  filterStartDate.value = new Date(tempStartDate);
  filterEndDate.value = (new Date(tempEndDate));
  doReladAfterDate.value = false;
  dropd.value = "";
  getInvoicesByFinancialGroup();
}

function clearDateFilters() {
  filterStartDate.value = null;
  filterEndDate.value = null;
  doReladAfterDate.value = true;
}

function showCurrentTransmissionHistory() {
  isPrecompleteChannel.value = false;
  currChannel.value = null;  
  isShowTransmissions.value = true;
  dropd.value = "";

  cnsApi.getCnsDashboard({financialgroupId: currFinancialGroup.value?.id, startDate: startDashboard.value, endDate: endDashboard.value})
    .then((result: CnsDashboard) => {
      cnsDashboard.value = result;
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail: t(error.status ? `error.${error.status}` : 'error.DEFAULT')
    });
  });
}

function initObserver() {
  if (!infiniteScrollTrigger.value) return

  observer?.disconnect();
  observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        loadMoreInvoices()
      }
    },
    {
      root: null,          
      rootMargin: "300px",
      threshold: 0         
    }
  )

  observer.observe(infiniteScrollTrigger.value)
}

const countsByTitle = computed(() => {

  const result: Record<string, number> = {};
  const data = summaryData.value;

  if (!data) return result;

  const add = (title: string | undefined, count: number | undefined) => {
    if (!title) return;
    result[title] = (result[title] ?? 0) + (count ?? 0);
  };

  const processChannels = (channels?: { title?: string; count?: number }[]) => {
    for (const c of channels ?? []) {
      if(c.title == 'RemainingBalance') {
        c.title = t('accounting.financialGroupMenu.fixChannels.remainingBalance');
      }
      add(c.title, c.count);
    }
  };

  processChannels(data.awaitingPayment);
  processChannels(data.cancelled);
  processChannels(data.revenues?.cash);
  processChannels(data.revenues?.immediatePayment);

  for (const account of data.revenues?.bankAccounts ?? []) {
    let sum = 0;

    for (const source of account.sources ?? []) {
      sum += source.count ?? 0;
    }

    add(account.title, sum);
  }

  return result;
});

watch(infiniteScrollTrigger, async (el) => {
  if (el) {
    await nextTick()
    initObserver()
  }
})

watch(
  () => appUserStore.refreshAccounting, 
  () => {
    if (appUserStore.refreshAccounting) {
      initialize();
    }
  }
);

watch(
  () => currentPersonId.value, 
  () => {
    initialize();
  }
);

onBeforeUnmount(() => {
  if (observer && infiniteScrollTrigger.value) {
    observer.unobserve(infiniteScrollTrigger.value)
  }
})

const pendingChannelId = ref<number | null>(null);
const pendingInvoiceRef = ref<string | null>(null);

watch(
  () => channelBtnRefs.value[Number(pendingChannelId.value)],
  async (el) => {
    if (!el || !pendingChannelId.value) return;
    const selected = selectedInvoices.value?.[0];
    if (!selected || selected.invoiceReference !== pendingInvoiceRef.value) return;
    pendingChannelId.value = null;
    pendingInvoiceRef.value = null;
    await nextTick();
    const btn = el.children[0];
    if (btn) {
      btn.click();
    } else {
      console.log('no child found in ref');
    }
  }
);

onMounted(async () => {
  checkPermission();
  const query = gen.deepCopy(route.query);
  const targetChannelId = query.targetChannelId;
  const invoiceRef = query.invoiceRef;
  // Pending ids must be set BEFORE initialize() so fetchPrecompleteInvoices
  // can select the target invoice on its first page-0 load.
  if (targetChannelId && invoiceRef) {
    pendingInvoiceRef.value = invoiceRef;
    pendingChannelId.value = Number.parseInt(targetChannelId);
  }
  await initialize();
});


return (_ctx: any,_cache: any) => {
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_switchGroup = _resolveComponent("switchGroup")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_esInputDateTime = _resolveComponent("esInputDateTime")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!currFinancialGroup.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(loadingSpinner, {
              logo: false,
              style: 'w-3'
            }),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('common.loading')), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('accounting.allMenu.title')), 1),
              _createVNode(_component_dropdownBox, {
                modelValue: dropd.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dropd).value = $event)),
                openOn: 'SearchTranversal',
                class: "mleft-08"
              }, {
                dropd: _withCtx(() => [
                  _createVNode(searchInvoice, { onInvoiceClicked: onSearchInvoiceClicked })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_buttonGroup, { styles: "pad-m" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _unref(SharedService).getIcon('magnifyingglass', false, 'menuIcons'),
                        class: "square-16 img-grey-dark"
                      }, null, 8, _hoisted_9)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_switchGroup, {
                  active: isPrecompleteChannel.value,
                  class: "mtop-04",
                  style: {"width":"max-content"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (onPrecompleteClicked()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('accounting.allMenu.precomplete'),
                      style: {"max-width":"7rem"},
                      styles: "main-m",
                      class: _normalizeClass(isPrecompleteChannel.value ? 'txt-white' : '')
                    }, null, 8, ["txt", "class"])
                  ]),
                  _: 1
                }, 8, ["active"])
              ]),
              (!selectedInvoices.value?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_text_item, {
                      txt: totalPreCompletInvoice.value?.toString(),
                      styles: "main-l",
                      style: {"margin-left":"auto"}
                    }, null, 8, ["txt"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_dropdownBox, {
                  modelValue: dropd.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dropd).value = $event)),
                  openOn: 'GroupMenu'
                }, {
                  dropd: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_text_item, {
                        txt: "Sélectionner",
                        styles: "font-mBold"
                      }),
                      _createVNode(_component_dbGroup, { class: "mtop-02" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allFinancialGroups.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "row"
                            }, [
                              _createVNode(_component_list_group, {
                                class: "w-full",
                                styles: "pad-s",
                                onClick: ($event: any) => (changeFinancialGroup(item))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["font-m main-h", {'txt-grey-40': !item.active}])
                                  }, _toDisplayString(item.active ? item.title : _unref(t)('accounting.financialGroupMenu.disabled', {'groupName': item.title})), 3)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_text_item, {
                        txt: currFinancialGroup.value.title,
                        styles: "font-mBold",
                        class: "mtop-20"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_dbGroup, { class: "mtop-02" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_list_group, {
                            class: "w-full gap-04",
                            styles: "pad-s",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (getCsv('luBills')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_item, { icon: "download" }),
                              _createVNode(_component_text_item, {
                                txt: _unref(t)('accounting.financialGroupMenu.groupActions.downloadBills')
                              }, null, 8, ["txt"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_list_group, {
                            class: "w-full gap-04",
                            styles: "pad-s",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (getCsv('luBilledActs')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_item, { icon: "download" }),
                              _createVNode(_component_text_item, {
                                txt: _unref(t)('accounting.financialGroupMenu.groupActions.downloadActs')
                              }, null, 8, ["txt"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_list_group, {
                            class: "w-full gap-04",
                            styles: "pad-s",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (getCsv('transactions')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_item, { icon: "download" }),
                              _createVNode(_component_text_item, {
                                txt: _unref(t)('accounting.financialGroupMenu.groupActions.downloadTransactions')
                              }, null, 8, ["txt"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_list_group, {
                            class: "w-full gap-04",
                            styles: "pad-s",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (getCsv('exportForBob50')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_item, { icon: "download" }),
                              _createVNode(_component_text_item, {
                                txt: _unref(t)('accounting.financialGroupMenu.groupActions.exportForBob50')
                              }, null, 8, ["txt"])
                            ]),
                            _: 1
                          }),
                          _cache[34] || (_cache[34] = _createElementVNode("div", {
                            class: "line-h",
                            style: {"margin-top":"0.5rem","margin-bottom":"0.5rem"}
                          }, null, -1)),
                          _createVNode(_component_list_group, {
                            class: "w-full gap-04",
                            styles: "pad-s",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (showCurrentTransmissionHistory()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_item, { icon: "documents" }),
                              _createVNode(_component_text_item, {
                                txt: _unref(t)('accounting.financialGroupMenu.groupActions.openPidDashboard')
                              }, null, 8, ["txt"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_buttonGroup, {
                      theme: "dropdown",
                      styles: "pad-s"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: currFinancialGroup.value.title,
                          styles: "font-mBold"
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (selectedInvoices.value?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_text_item, {
                        txt: selectedInvoicesAmount.value,
                        styles: "main-m"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_text_item, {
                        txt: '(' + selectedInvoices.value.length.toString() + ')',
                        styles: "main-m",
                        class: "mleft-06"
                      }, null, 8, ["txt"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allCurrChannels.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "row"
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_switchGroup, {
                      active: currChannel.value?.id === item.id,
                      class: "w-full rowcenter",
                      style: {"width":"max-content"},
                      onClick: ($event: any) => (switchChannel(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: item.title,
                          style: {"max-width":"8.5rem"},
                          styles: "main-m",
                          class: _normalizeClass(currChannel.value?.id === item.id ? 'txt-white' : '')
                        }, null, 8, ["txt", "class"])
                      ]),
                      _: 2
                    }, 1032, ["active", "onClick"])
                  ]),
                  (!selectedInvoices.value?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(countsByTitle.value[item.title]), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (selectedInvoices.value?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (isDirectTargetChannel(item))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              ref_for: true,
                              ref: (el) => channelBtnRefs.value[item.id] = el
                            }, [
                              _createVNode(_component_buttonGroup, {
                                styles: "pad-s",
                                onClick: ($event: any) => (addTransactionsBtn(item))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_dropdownBox, {
                                    modelValue: dropd.value,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dropd).value = $event)),
                                    openOn: 'DoTransaction' + item.id,
                                    class: "mleft-auto"
                                  }, {
                                    dropd: _withCtx(() => [
                                      _createVNode(doTransaction, {
                                        selectedInvoices: selectedInvoices.value,
                                        sourceFinancialChannel: currChannel.value,
                                        targetFinancialChannel: item,
                                        financialGroupId: currFinancialGroup.value.id,
                                        onReload: ($event: any) => (reloadAndSwitch(item))
                                      }, null, 8, ["selectedInvoices", "sourceFinancialChannel", "targetFinancialChannel", "financialGroupId", "onReload"])
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "openOn"]),
                                  _createVNode(_component_dropdownBox, {
                                    modelValue: dropd.value,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dropd).value = $event)),
                                    openOn: 'PidRa' + item.id,
                                    class: "mleft-auto"
                                  }, {
                                    dropd: _withCtx(() => [
                                      _createVNode(luPid, {
                                        invoice: currSinglePrecompleteInvoice.value,
                                        isPidTargetChannel: isPidTargetChannel(item),
                                        financialChannel: item,
                                        eConnectorApiError: eConnectorApiError.value,
                                        mockMode: mockMode.value,
                                        eConnectorActivated: eConnectorActivated.value,
                                        simulationAnomalies: simulationAnomalies.value,
                                        financialGroupId: currFinancialGroup.value.id,
                                        eConnectorAwaiting: eConnectorAwaiting.value,
                                        onReload: ($event: any) => (reloadAndSwitch(item)),
                                        onRedoPidSimulation: ($event: any) => (redoPidSimulation(currSinglePrecompleteInvoice.value, item))
                                      }, null, 8, ["invoice", "isPidTargetChannel", "financialChannel", "eConnectorApiError", "mockMode", "eConnectorActivated", "simulationAnomalies", "financialGroupId", "eConnectorAwaiting", "onReload", "onRedoPidSimulation"])
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "openOn"]),
                                  _createVNode(_component_dropdownBox, {
                                    modelValue: dropd.value,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dropd).value = $event)),
                                    openOn: 'Cancel' + item.id,
                                    class: "mleft-auto"
                                  }, {
                                    dropd: _withCtx(() => [
                                      _createVNode(luBillCancellation, {
                                        invoice: singleInvoice.value,
                                        financialChannel: item,
                                        eConnectorApiError: eConnectorApiError.value,
                                        mockMode: mockMode.value,
                                        eConnectorActivated: eConnectorActivated.value,
                                        financialGroupId: currFinancialGroup.value.id,
                                        onReload: ($event: any) => (reloadAndSwitch(item))
                                      }, null, 8, ["invoice", "financialChannel", "eConnectorApiError", "mockMode", "eConnectorActivated", "financialGroupId", "onReload"])
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "openOn"]),
                                  (item.active)
                                    ? (_openBlock(), _createBlock(_component_svg_item, {
                                        key: 0,
                                        icon: "arrowLeft",
                                        class: "mtop-01"
                                      }))
                                    : _createCommentVNode("", true),
                                  (item.active)
                                    ? (_openBlock(), _createBlock(_component_text_item, {
                                        key: 1,
                                        txt: getChannelActionTerm(item),
                                        class: "mleft-04"
                                      }, null, 8, ["txt"]))
                                    : _createCommentVNode("", true),
                                  (eConnectorActivated.value && isPidTargetChannel(item))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        (eConnectorApiError.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                              _createVNode(_component_text_item, {
                                                class: "text-error",
                                                txt: "CNS no port",
                                                styles: "font-s"
                                              })
                                            ]))
                                          : (eConnectorAwaiting.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                _createVNode(_component_text_item, {
                                                  txt: "CNS",
                                                  styles: "main-m font-s"
                                                }),
                                                _cache[35] || (_cache[35] = _createElementVNode("img", {
                                                  src: _imports_0,
                                                  class: "mtop-01 mleft-06",
                                                  style: {"height":"0.7rem"}
                                                }, null, -1))
                                              ]))
                                            : (getCnsStatus(currSinglePrecompleteInvoice.value) === 'pidContestation')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                  _createVNode(_component_text_item, {
                                                    class: "text-error",
                                                    txt: "PID contesté",
                                                    styles: "font-s"
                                                  })
                                                ]))
                                              : (currSinglePrecompleteInvoice.value && currSinglePrecompleteInvoice.value.simulationError === true)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                    _createVNode(_component_text_item, {
                                                      class: "text-error",
                                                      txt: "PID refus",
                                                      styles: "font-s"
                                                    })
                                                  ]))
                                                : (currSinglePrecompleteInvoiceHasSimulationError.value)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                      _createVNode(_component_text_item, {
                                                        class: "text-error",
                                                        txt: "CNS err",
                                                        styles: "font-s"
                                                      })
                                                    ]))
                                                  : (!isForNewPidSimulation(currSinglePrecompleteInvoice.value))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                        _createVNode(_component_text_item, {
                                                          class: "text-ok",
                                                          txt: "PID ok",
                                                          styles: "font-s"
                                                        })
                                                      ]))
                                                    : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ], 512))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  (selectedInvoices.value?.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!isPrecompleteChannel.value)
                          ? (_openBlock(), _createBlock(_component_dropdownBox, {
                              key: 0,
                              modelValue: dropd.value,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((dropd).value = $event)),
                              openOn: "printOptions"
                            }, {
                              dropd: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: "bg-modal w-maxC",
                                  style: {"padding":"0.3rem"},
                                  onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
                                }, [
                                  _createVNode(_component_dbGroup, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_list_group, {
                                        class: "w-full",
                                        styles: "pad-m",
                                        onClick: _cache[11] || (_cache[11] = ($event: any) => (printSelected()))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_svg_item, {
                                            icon: "printer",
                                            styles: "main-m",
                                            class: "mtop-01"
                                          }),
                                          _createVNode(_component_text_item, {
                                            txt: _unref(t)('accounting.invoiceReminder.selectionAlone'),
                                            class: "mleft-04"
                                          }, null, 8, ["txt"])
                                        ]),
                                        _: 1
                                      }),
                                      (currChannel.value?.type === 'RemainingBalance' && hasSelectionReprintable.value)
                                        ? (_openBlock(), _createBlock(_component_list_group, {
                                            key: 0,
                                            class: "w-full",
                                            styles: "pad-m",
                                            onClick: _cache[12] || (_cache[12] = ($event: any) => (printSelectedWithReminders()))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_svg_item, {
                                                icon: "printer",
                                                styles: "main-m",
                                                class: "mtop-01"
                                              }),
                                              _createVNode(_component_text_item, {
                                                txt: _unref(t)('accounting.invoiceReminder.selectionWithReminders'),
                                                class: "mleft-04"
                                              }, null, 8, ["txt"])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_buttonGroup, { styles: "pad-s" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_item, {
                                      icon: "printer",
                                      styles: "main-m",
                                      class: "mtop-01"
                                    }),
                                    _createVNode(_component_text_item, {
                                      txt: _unref(t)('action.print'),
                                      class: "mleft-04"
                                    }, null, 8, ["txt"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        (currChannel.value?.type === 'RemainingBalance' && selectedStandardInvoices.value?.length)
                          ? (_openBlock(), _createBlock(_component_dropdownBox, {
                              key: 1,
                              modelValue: dropd.value,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((dropd).value = $event)),
                              openOn: "createReminders"
                            }, {
                              dropd: _withCtx(() => [
                                _createVNode(createReminders, {
                                  selectedInvoices: selectedStandardInvoices.value,
                                  financialGroup: currFinancialGroup.value,
                                  onReload: _cache[15] || (_cache[15] = ($event: any) => (reload()))
                                }, null, 8, ["selectedInvoices", "financialGroup"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_buttonGroup, {
                                  styles: "pad-s",
                                  class: "mtop-03"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_item, {
                                      icon: "documents",
                                      styles: "main-h",
                                      class: "mtop-02"
                                    }),
                                    _createVNode(_component_text_item, {
                                      txt: _unref(t)('accounting.financialGroupMenu.channelActions.createPaymentReminders'),
                                      class: "mleft-03"
                                    }, null, 8, ["txt"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        (currChannel.value?.type === 'LuTp')
                          ? (_openBlock(), _createBlock(_component_dropdownBox, {
                              key: 2,
                              modelValue: dropd.value,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((dropd).value = $event)),
                              openOn: "createTpSheet"
                            }, {
                              dropd: _withCtx(() => [
                                _createVNode(createTiersPayant, {
                                  selectedInvoices: selectedInvoices.value,
                                  tpType: "tp",
                                  onReload: _cache[17] || (_cache[17] = ($event: any) => (reload()))
                                }, null, 8, ["selectedInvoices"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_buttonGroup, { styles: "pad-s" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_item, {
                                      icon: "file",
                                      styles: "main-h",
                                      class: "mtop-03"
                                    }),
                                    _createVNode(_component_text_item, {
                                      txt: _unref(t)('accounting.financialGroupMenu.channelActions.createLuTpSheet'),
                                      class: "mleft-04"
                                    }, null, 8, ["txt"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        (currChannel.value?.type === 'LuTpSocial')
                          ? (_openBlock(), _createBlock(_component_dropdownBox, {
                              key: 3,
                              modelValue: dropd.value,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((dropd).value = $event)),
                              openOn: "createTpSheet"
                            }, {
                              dropd: _withCtx(() => [
                                _createVNode(createTiersPayant, {
                                  selectedInvoices: selectedInvoices.value,
                                  tpType: "tpSocial",
                                  onReload: _cache[19] || (_cache[19] = ($event: any) => (reload()))
                                }, null, 8, ["selectedInvoices"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_buttonGroup, { styles: "pad-s" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_item, {
                                      icon: "file",
                                      styles: "main-m",
                                      class: "mtop-01"
                                    }),
                                    _createVNode(_component_text_item, {
                                      txt: _unref(t)('accounting.financialGroupMenu.channelActions.createLuTpSocialSheet'),
                                      class: "mleft-04"
                                    }, null, 8, ["txt"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                (mockMode.value !== MockMode.OFF)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (mockMode.value === MockMode.ECONNECTOR_DISABLED)
                        ? (_openBlock(), _createBlock(_component_text_item, {
                            key: 0,
                            txt: "Mocking: eConnector not active",
                            class: "text-ok",
                            styles: "font-s"
                          }))
                        : _createCommentVNode("", true),
                      (mockMode.value === MockMode.ECONNECTOR_NO_PORT)
                        ? (_openBlock(), _createBlock(_component_text_item, {
                            key: 1,
                            txt: "Mocking: eConnector noPort",
                            class: "text-ok",
                            styles: "font-s"
                          }))
                        : _createCommentVNode("", true),
                      (mockMode.value === MockMode.ECONNECTOR_ERROR)
                        ? (_openBlock(), _createBlock(_component_text_item, {
                            key: 2,
                            txt: "Mocking: eConnectorError",
                            class: "text-ok",
                            styles: "font-s"
                          }))
                        : _createCommentVNode("", true),
                      (mockMode.value === MockMode.PID_REFUSED)
                        ? (_openBlock(), _createBlock(_component_text_item, {
                            key: 3,
                            txt: "Mocking: PID refusé",
                            class: "text-ok",
                            styles: "font-s"
                          }))
                        : _createCommentVNode("", true),
                      (mockMode.value === MockMode.PID_OK)
                        ? (_openBlock(), _createBlock(_component_text_item, {
                            key: 4,
                            txt: "Mocking: PID Ok",
                            class: "text-ok",
                            styles: "font-s"
                          }))
                        : _createCommentVNode("", true),
                      (!eConnectorActivated.value)
                        ? (_openBlock(), _createBlock(_component_text_item, {
                            key: 5,
                            txt: "eConnector not activated",
                            class: "text-error",
                            styles: "font-s"
                          }))
                        : _createCommentVNode("", true),
                      (currSinglePrecompleteInvoice.value?.simulationError)
                        ? (_openBlock(), _createBlock(_component_text_item, {
                            key: 6,
                            txt: "PID: contesté",
                            class: "text-error",
                            styles: "font-s"
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (eConnectorActivated.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (eConnectorApiError.value)
                        ? (_openBlock(), _createBlock(_component_text_item, {
                            key: 0,
                            txt: _unref(t)('accounting.econnector.service.noPort'),
                            class: "text-error",
                            styles: "font-s"
                          }, null, 8, ["txt"]))
                        : (currSinglePrecompleteInvoiceHasSimulationError.value)
                          ? (_openBlock(), _createBlock(_component_text_item, {
                              key: 1,
                              txt: _unref(t)('accounting.econnector.service.error'),
                              class: "text-error",
                              styles: "font-s"
                            }, null, 8, ["txt"]))
                          : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            (isShowTransmissions.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createVNode(EsCnsDashboard, {
                    groupName: currFinancialGroup.value.title,
                    cnsDashboard: cnsDashboard.value,
                    start: startDashboard.value,
                    end: endDashboard.value
                  }, null, 8, ["groupName", "cnsDashboard", "start", "end"])
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["col w-full", eConnectorApiError.value ? 'h-95p' : 'h-full'])
                }, [
                  (isRefPillMode.value || !isPrecompleteChannel.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_34, [
                          (isRefPillMode.value)
                            ? (_openBlock(), _createBlock(_component_buttonGroup, {
                                key: 0,
                                styles: "pad-s border-m",
                                class: "gap-04 psides-06",
                                onClick: _cache[21] || (_cache[21] = ($event: any) => (clearFilterRefNumber()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_text_item, {
                                    txt: filterRefNumber.value,
                                    styles: "font-mBold main-m"
                                  }, null, 8, ["txt"]),
                                  _createElementVNode("img", {
                                    src: _unref(SharedService).getIcon('xmark', false, 'shareIcons'),
                                    class: "mtop-03 mleft-02 img-grey-dark"
                                  }, null, 8, _hoisted_35)
                                ]),
                                _: 1
                              }))
                            : (!isPrecompleteChannel.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  (filterPwrPatient.value)
                                    ? (_openBlock(), _createBlock(_component_buttonGroup, {
                                        key: 0,
                                        styles: "pad-s border-m",
                                        class: "gap-04 psides-06",
                                        onClick: _cache[22] || (_cache[22] = ($event: any) => (changeFilterPwrPatient(null)))
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", {
                                            src: _unref(SharedService).getIcon('person', false, 'menuIcons'),
                                            class: "img-grey mtop-03"
                                          }, null, 8, _hoisted_37),
                                          _createVNode(_component_text_item, {
                                            txt: filterPwrPatient.value.lastName,
                                            styles: "font-mBold main-m"
                                          }, null, 8, ["txt"]),
                                          _createVNode(_component_text_item, {
                                            txt: filterPwrPatient.value.firstName,
                                            styles: "font-mBold main-m"
                                          }, null, 8, ["txt"]),
                                          _createElementVNode("img", {
                                            src: _unref(SharedService).getIcon('xmark', false, 'shareIcons'),
                                            class: "img-grey mtop-03 mleft-02"
                                          }, null, 8, _hoisted_38)
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_dropdownBox, {
                                        key: 1,
                                        modelValue: dropd.value,
                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((dropd).value = $event)),
                                        openOn: 'FilterPatient'
                                      }, {
                                        dropd: _withCtx(() => [
                                          _createVNode(patientChange, { onSelectedPatient: changeFilterPwrPatient })
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_buttonGroup, {
                                            theme: "dropdown",
                                            class: "psides-06",
                                            styles: "pad-s border-m"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(SharedService).getIcon('person', false, 'menuIcons'),
                                                class: "img-grey mtop-03"
                                              }, null, 8, _hoisted_39),
                                              _createVNode(_component_text_item, {
                                                txt: _unref(t)('accounting.filterMenu.patient'),
                                                styles: "font-mBold main-m",
                                                class: "mleft-04"
                                              }, null, 8, ["txt"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])),
                                  (filterPwrHealthPro.value)
                                    ? (_openBlock(), _createBlock(_component_buttonGroup, {
                                        key: 2,
                                        styles: "pad-s border-m",
                                        class: "gap-04 psides-06",
                                        onClick: _cache[24] || (_cache[24] = ($event: any) => (changeFilterPwrHealthPro(null)))
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", {
                                            src: _unref(SharedService).getIcon('stethoscope', false, 'shareIcons'),
                                            class: "mtop-03"
                                          }, null, 8, _hoisted_40),
                                          _createVNode(_component_text_item, {
                                            txt: filterPwrHealthPro.value.lastName,
                                            styles: "font-mBold main-m"
                                          }, null, 8, ["txt"]),
                                          _createVNode(_component_text_item, {
                                            txt: filterPwrHealthPro.value.firstName,
                                            styles: "font-mBold main-m"
                                          }, null, 8, ["txt"]),
                                          _createElementVNode("img", {
                                            src: _unref(SharedService).getIcon('xmark', false, 'shareIcons'),
                                            class: "img-grey mtop-03 mleft-02"
                                          }, null, 8, _hoisted_41)
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_dropdownBox, {
                                        key: 3,
                                        modelValue: dropd.value,
                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((dropd).value = $event)),
                                        openOn: 'FilterHealthPro'
                                      }, {
                                        dropd: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_43, [
                                            _createVNode(_component_dbGroup, null, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allHealthPro.value, (healthPro, index) => {
                                                  return (_openBlock(), _createBlock(_component_list_group, {
                                                    key: index,
                                                    class: "w-full gap-04",
                                                    styles: "pad-s",
                                                    onClick: ($event: any) => (changeFilterPwrHealthPro(healthPro))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", _hoisted_44, _toDisplayString(healthPro.lastName), 1),
                                                      _createElementVNode("span", _hoisted_45, _toDisplayString(healthPro.firstName), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_buttonGroup, {
                                            theme: "dropdown",
                                            class: "psides-06",
                                            styles: "pad-s border-m"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(SharedService).getIcon('stethoscope', false, 'shareIcons'),
                                                class: "mtop-03"
                                              }, null, 8, _hoisted_42),
                                              _createVNode(_component_text_item, {
                                                txt: _unref(t)('accounting.filterMenu.healthPro'),
                                                styles: "font-mBold main-m",
                                                class: "mleft-04"
                                              }, null, 8, ["txt"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])),
                                  _createVNode(_component_dropdownBox, {
                                    modelValue: dropd.value,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((dropd).value = $event)),
                                    openOn: 'FilterDate'
                                  }, {
                                    dropd: _withCtx(() => [
                                      _createElementVNode("div", {
                                        class: "bg-modal w-maxC",
                                        onClick: _cache[28] || (_cache[28] = _withModifiers(() => {}, ["stop"]))
                                      }, [
                                        _createVNode(_component_esInputDateTime, {
                                          inline: "",
                                          dateTimeValue: [new Date(), new Date()],
                                          dateFormat: _unref(DateFormat).DATEPICKER,
                                          range: true,
                                          withTime: false,
                                          onUpdateDateTime: _cache[27] || (_cache[27] = ($event: any) => (changeFilterDate($event)))
                                        }, null, 8, ["dateTimeValue", "dateFormat"])
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      (filterStartDate.value)
                                        ? (_openBlock(), _createBlock(_component_buttonGroup, {
                                            key: 0,
                                            styles: "pad-s border-m",
                                            class: "gap-04 psides-06",
                                            onClick: _cache[26] || (_cache[26] = ($event: any) => (clearDateFilters()))
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(SharedService).getIcon('calendar', false, 'shareIcons'),
                                                class: "mtop-03"
                                              }, null, 8, _hoisted_46),
                                              (filterStartDate.value)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_unref(format)(filterStartDate.value, _unref(DateFormat).FRONT_LONG)), 1))
                                                : _createCommentVNode("", true),
                                              (filterEndDate.value && (!_unref(isSameDay)(filterEndDate.value, filterStartDate.value)))
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _cache[36] || (_cache[36] = _createElementVNode("span", { class: "font-mBold main-m" }, "-", -1)),
                                                    _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(format)(filterEndDate.value, _unref(DateFormat).FRONT_LONG)), 1)
                                                  ], 64))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_buttonGroup, {
                                            key: 1,
                                            theme: "dropdown",
                                            class: "psides-06",
                                            styles: "pad-s border-m"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: _unref(SharedService).getIcon('calendar', false, 'shareIcons'),
                                                class: "mtop-03"
                                              }, null, 8, _hoisted_49),
                                              _createVNode(_component_text_item, {
                                                txt: _unref(t)('accounting.filterMenu.date'),
                                                styles: "font-mBold main-m",
                                                class: "mleft-04"
                                              }, null, 8, ["txt"])
                                            ]),
                                            _: 1
                                          }))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createVNode(_component_dropdownBox, {
                                    modelValue: dropd.value,
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((dropd).value = $event)),
                                    openOn: "FinancialSummary"
                                  }, {
                                    dropd: _withCtx(() => [
                                      _createVNode(financialSummary, {
                                        financialGroupId: currFinancialGroup.value.id,
                                        financialGroupTitle: currFinancialGroup.value.title,
                                        startDate: filterStartDate.value,
                                        endDate: filterEndDate.value,
                                        healthProId: filterPwrHealthPro.value?.id,
                                        healthProName: filterPwrHealthPro.value ? (filterPwrHealthPro.value.lastName + ' ' + filterPwrHealthPro.value.firstName) : null,
                                        patientId: filterPwrPatient.value?.personWithRoleId,
                                        patientName: filterPwrPatient.value ? (filterPwrPatient.value.lastName + ' ' + filterPwrPatient.value.firstName) : null,
                                        data: summaryData.value
                                      }, null, 8, ["financialGroupId", "financialGroupTitle", "startDate", "endDate", "healthProId", "healthProName", "patientId", "patientName", "data"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_buttonGroup, { class: "mleft-15 psides-06" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_svg_item, { icon: "documents" }),
                                          _createVNode(_component_text_item, {
                                            txt: "Info",
                                            styles: "font-mBold main-m",
                                            class: "mleft-04"
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]))
                              : _createCommentVNode("", true)
                        ]),
                        _cache[37] || (_cache[37] = _createElementVNode("div", { class: "mtop-25" }, null, -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_50, [
                    (isPrecompleteChannel.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(precompleteInvoices.value, (invoice) => {
                            return (_openBlock(), _createBlock(invoiceCard, {
                              key: invoice.id,
                              invoice: invoice,
                              currFinancialGroup: invoice.financialGroup,
                              pwrHealthPro: invoice.pwrHealthPro,
                              onReload: _cache[31] || (_cache[31] = ($event: any) => (reload())),
                              onCtaClicked: ctaClicked
                            }, null, 8, ["invoice", "currFinancialGroup", "pwrHealthPro"]))
                          }), 128)),
                          _createElementVNode("div", {
                            ref_key: "infiniteScrollTrigger",
                            ref: infiniteScrollTrigger,
                            style: {"height":"1px"}
                          }, null, 512),
                          (loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                _createVNode(loadingSpinner, {
                                  logo: false,
                                  style: 'w-3'
                                }),
                                _createElementVNode("span", _hoisted_53, _toDisplayString(_unref(t)('common.loading')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (!loading.value && !hasMorePreCompletInvoice.value && precompleteInvoices.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_unref(t)('accounting.noData')), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _createVNode(loadingSpinner, {
                                  logo: false,
                                  style: 'w-3'
                                }),
                                _createElementVNode("span", _hoisted_56, _toDisplayString(_unref(t)('common.loading')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (hasMore.value && currChannel.value?.invoiceGroups.length != 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_unref(t)('accounting.hasMore')), 1))
                            : _createCommentVNode("", true),
                          (hasInvoices.value)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(currChannel.value?.invoiceGroups, (invoiceGroup, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                  (invoiceGroup?.invoices?.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                        _createElementVNode("div", _hoisted_59, [
                                          _createVNode(_component_text_item, {
                                            txt: invoiceGroup.text,
                                            styles: "font-mBold main-l"
                                          }, null, 8, ["txt"]),
                                          _createVNode(_component_buttonGroup, {
                                            styles: "pad-s",
                                            class: "psides-04",
                                            onClick: ($event: any) => (selectAll(invoiceGroup))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_svg_item, { icon: "check" })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          (currChannel.value?.type === 'LuTp' && invoiceGroup.key !== 'notSubmitted')
                                            ? (_openBlock(), _createBlock(_component_dropdownBox, {
                                                key: 0,
                                                modelValue: dropd.value,
                                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((dropd).value = $event)),
                                                openOn: 'showTpSheet' + invoiceGroup.key
                                              }, {
                                                dropd: _withCtx(() => [
                                                  _createVNode(showTiersPayant, {
                                                    tpUuid: invoiceGroup.key
                                                  }, null, 8, ["tpUuid"])
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_buttonGroup, {
                                                    styles: "pad-s",
                                                    class: "psides-04 mleft-30"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_svg_item, {
                                                        icon: "file",
                                                        styles: "main-m"
                                                      }),
                                                      _createVNode(_component_text_item, {
                                                        txt: _unref(t)('accounting.financialGroupMenu.luTpSheet'),
                                                        styles: "main-m",
                                                        class: "mleft-02"
                                                      }, null, 8, ["txt"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "openOn"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_60, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoiceGroup.invoices, (invoice, idx) => {
                                            return (_openBlock(), _createBlock(invoiceCard, {
                                              key: idx,
                                              invoice: invoice,
                                              currChannel: currChannel.value,
                                              allCurrChannels: allCurrChannels.value,
                                              pwrHealthPro: invoice.pwrHealthPro,
                                              hasMultipleHealthPro: hasMultipleHealthPro.value,
                                              onReload: _cache[33] || (_cache[33] = ($event: any) => (reload()))
                                            }, null, 8, ["invoice", "currChannel", "allCurrChannels", "pwrHealthPro", "hasMultipleHealthPro"]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            : (!loading.value && !hasMore.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_unref(t)('accounting.noData')), 1))
                              : _createCommentVNode("", true)
                        ], 64))
                  ])
                ], 2))
          ])
        ]))
  ]))
}
}

})